import { DatePicker, Form } from 'antd-mobile-v5'
import React, { useState } from 'react'

import { formatDate } from '../common/utils'

import styles from './tools.module.css'

const DatePickerTool = (props) => {
  const { name, rules, label, max, min, disabled, placeholder } = props

  const [visible, setVisible] = useState(false)

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      trigger="onConfirm"
      onClick={() => setVisible(!disabled)}
      {...props}
    >
      <DatePicker
        visible={visible}
        onClose={() => {
          setVisible(false)
        }}
        min={min}
        max={max}
      >
        {(value) => (value ? formatDate(value, 'YYYY-MM-DD') : <span className={styles.picker}>{placeholder}</span>)}
      </DatePicker>
    </Form.Item>
  )
}

export default DatePickerTool
